<div class="flex gap-3 flex-wrap mt-3 justify-content-between">
    <div class="flex gap-3 flex-wrap">
        <div class="flex-nowrap flex gap-2 align-items-center" *ngIf="questionPageHiddenLog > 0">
            <img src="assets/vinter/icons/cheating-icon.svg">
            <p class="font-medium page-hidden">{{"Key.SwitchTab" | translate: {value: questionPageHiddenLog } }}</p>
        </div>
        <div *ngIf="!showDetails && answer?.isFaceDetected && answer?.isAllowedDifferentFaceAnalysis"
            class="flex-nowrap flex gap-2 align-items-center">
            <img src="assets/vinter/icons/face-detection-icon.svg" class="detect-img">
            <p class="font-medium face-detected">{{"Key.FaceDetected" | translate }}</p>
        </div>
        <div *ngIf="!showDetails && answer?.isMultiFaceDetected && answer?.isAllowedMultipleFaceAnalysis"
            class="flex-nowrap flex gap-2 align-items-center">
            <img src="assets/vinter/icons/multiface-detected-icon.svg" class="detect-img">
            <p class="font-medium multiface-detected">{{"Key.MultiFaceDetected" | translate }}</p>
        </div>
        <div *ngIf="!showDetails && answer?.faceDetectionStatus === EFaceDetectionStatus.VerifiedAndNonFace ||
        !showDetails && answer?.faceDetectionStatus === EFaceDetectionStatus.UnverifiedAndNonFace"
            class="flex-nowrap flex gap-2 align-items-center">
            <img src="assets/vinter/icons/face-detection-status-icon.svg" class="detect-img">
            <p class="font-medium impropriety-speech">{{"Key.FaceDetectionStatus" | translate }}</p>
        </div>
    </div>
    <button *ngIf="
    questionPageHiddenLog > 0 ||
    answer?.isFaceDetected ||
    answer?.isMultiFaceDetected ||
    answer?.faceDetectionStatus === EFaceDetectionStatus.VerifiedAndNonFace ||
    answer?.faceDetectionStatus === EFaceDetectionStatus.UnverifiedAndNonFace
  " pButton type="button" class="p-button-text analysis-button" (click)="toggleDetails()" iconPos="right"
        [icon]="showDetails ? 'pi pi-chevron-up' : 'pi pi-chevron-right'"
        [label]="'Key.AnalysisDetail' | translate"></button>

</div>
<div class="thumbnail-wrapper mt-3  pb-2 overflow-hidden border-round-sm" *ngIf="showDetails && CheatingPicturesUrls.length">
    <p-carousel [value]="CheatingPicturesUrls" [numVisible]="4" [showIndicators]="false" [circular]="false" [autoplayInterval]="0"
        class="cheating-carousel p-2">
        <ng-template pTemplate="item" let-img>
            <div class="flex justify-content-center align-content-center">
                <p-image [src]="img" [alt]="'Görüntü önizleme'" [preview]="true" appendTo="body" width="150"
                    height="111" class="shadow-2 cursor-pointer border-round-sm	  thumbnail-img"></p-image>
            </div>
        </ng-template>
    </p-carousel>

    <div *ngIf="isFaceDivVisible && answer?.isFaceDetected && answer?.isAllowedDifferentFaceAnalysis"
        class="px-3 flex flex-row justify-content-between  mt-2">
        <div class="flex justif-content-center align-items-center gap-2">
            <img src="assets/vinter/icons/face-detection-icon.svg" class="detect-img">
            <p class="font-medium face-detected">{{"Key.FaceDetected" | translate }}</p>
        </div>
        <div class="flex justif-content-center align-items-center gap-3">
            <span class="flex-grow-1 text-center text-gray-500">{{"Key.copyQuestionText" | translate }}</span>
            <div class="flex gap-2">
                <button pButton (click)="hideWarningAndSaveLog(detectionTypeEnum.FaceDetected, decisionTypeEnum.HRConfirmed)"
                type="button" icon="pi pi-check-circle" label="{{ 'Key.Yes' | translate }}"
                    class="p-button p-button-sm p-button-success p-button-outlined"></button>

                <button pButton (click)="hideWarningAndSaveLog(detectionTypeEnum.FaceDetected, decisionTypeEnum.HRRejected)"
                type="button" icon="pi pi-times-circle" label="{{ 'Key.No' | translate }}"
                    class="p-button p-button-sm p-button-danger p-button-outlined"></button>
            </div>
        </div>
    </div>
    <div *ngIf="isMultiFaceDivVisible && answer?.isMultiFaceDetected && answer?.isAllowedMultipleFaceAnalysis"
        class="px-3 flex flex-row justify-content-between  mt-2">
        <div class="flex justif-content-center align-items-center gap-2">
            <img src="assets/vinter/icons/multiface-detected-icon.svg" class="detect-img">
            <p class="font-medium multiface-detected">{{"Key.MultiFaceDetected" | translate }}</p>
        </div>
        <div class="flex justif-content-center align-items-center gap-3">
            <span class="flex-grow-1 text-center text-gray-500">{{"Key.copyQuestionText" | translate }}</span>
            <div class="flex gap-2">
                <button pButton (click)="hideWarningAndSaveLog(detectionTypeEnum.MultiFaceDetected,decisionTypeEnum.HRConfirmed)"
                type="button" icon="pi pi-check-circle" label="{{ 'Key.Yes' | translate }}"
                    class="p-button p-button-sm p-button-success p-button-outlined"></button>

                <button pButton (click)="hideWarningAndSaveLog(detectionTypeEnum.MultiFaceDetected,decisionTypeEnum.HRRejected)"
                type="button" icon="pi pi-times-circle" label="{{ 'Key.No' | translate }}"
                    class="p-button p-button-sm p-button-danger p-button-outlined"></button>
            </div>
        </div>
    </div>
    <div *ngIf="isNonFaceDivVisible && answer?.faceDetectionStatus === EFaceDetectionStatus.VerifiedAndNonFace ||
    answer?.faceDetectionStatus === EFaceDetectionStatus.UnverifiedAndNonFace"
        class="px-3 flex flex-row justify-content-between  mt-2">
        <div class="flex justif-content-center align-items-center gap-2">
            <img src="assets/vinter/icons/face-detection-status-icon.svg" class="detect-img">
            <p class="font-medium impropriety-speech">{{"Key.FaceDetectionStatus" | translate }}</p>
        </div>
        <div class="flex justif-content-center align-items-center gap-3">
            <span class="flex-grow-1 text-center text-gray-500 ">{{"Key.copyQuestionText" | translate }}</span>
            <div class="flex gap-2">
                <button pButton (click)="hideWarningAndSaveLog(detectionTypeEnum.VerifiedNonFace,decisionTypeEnum.HRConfirmed)" type="button" icon="pi pi-check-circle" label="{{ 'Key.Yes' | translate }}"
                    class="p-button p-button-sm p-button-success p-button-outlined"></button>

                <button pButton (click)="hideWarningAndSaveLog(detectionTypeEnum.VerifiedNonFace,decisionTypeEnum.HRRejected)" type="button" icon="pi pi-times-circle" label="{{ 'Key.No' | translate }}"
                    class="p-button p-button-sm p-button-danger p-button-outlined"></button>
            </div>
        </div>
    </div>
</div>

<ng-template #noImages>
    <p class="text-secondary">{{"Key.ImageNotFound" | translate}}
    </p>
</ng-template>


<div class="flex">
    <img src="assets/vinter/icons/text-questioncoktan-secmeli-cevap-icon-arrow-back-up.svg">
    <h5 class="text-justify answer-title font-semibold text-lg ml-2">
        {{"Key.Answer" | translate}}
    </h5>
</div>

<div *ngIf="answer?.answerContent ?? false" class="answer-container border-1 border-solid ml-5 border-round-md">
    <div class="answer-text-label text-justify text-justify">
        {{ answer?.answerContent.answerText }}
    </div>
</div>

<div *ngIf="answer?.answerContent?? false" class="answer-text pt-0">
    <div class="flex">
        <h5 class="text-justify answer-title font-semibold text-lg ml-2 mb-2 pl-4 m-3">
            {{'Key.VinterComment' | translate}}
        </h5>
    </div>

    <div class="ai-comment-container ml-5 border-1 border-solid border-round-md border-gray-50" [ngClass]="{'justify-content-center': answer?.answerContent?.gptEvalStatus === gptEvalStatusEnum.Retry}">
        <img [src]="vinterAICommentIcon">
        <div class="text-blue-800 text-justify mt-2" *ngIf="answer?.answerContent?.gptEvalStatus === gptEvalStatusEnum.Succesful">
            {{ answer?.answerContent.gptEvalText }}
        </div>

        <div class="answer-text-label text-justify" *ngIf="answer?.answerContent?.gptEvalStatus === gptEvalStatusEnum.ClientFail">
            {{ answer?.answerContent.aiFinalLog }}
        </div>

        <div class="retry-container border-2 border-solid h-13rem w-15rem bg-white" *ngIf="answer?.answerContent?.gptEvalStatus === gptEvalStatusEnum.Retry">
            <div class="grid">
                <div class="col-12 flex justify-content-center">
                    <img src="../../../../../assets/vinter/icons/gpt-sleep.svg" class="w-4rem pt-3" >
                </div>
                <div class="col-12 flex justify-content-center text-gray-700 text-sm font-medium py-0 text-center">
                    {{"Key.GptRetryMessage" | translate}}
                </div>
                <div class="col-12 pt-4 flex justify-content-center">
                    <img src="../../../../../assets/vinter/icons/retry-icon.svg" (click)="setGptStatus()" class="w-1rem mr-2 cursor-pointer">
                    <p class="text-blue-500 cursor-pointer" (click)="setGptStatus()">{{"Key.Retry" | translate}}</p>
                </div>
            </div>
        </div>

        <div class="answer-text-label text-justify" *ngIf="answer?.answerContent?.gptEvalStatus === gptEvalStatusEnum.Fail">
            {{"Key.GptFailStatusMessage" | translate}}
        </div>

        <div class="answer-text-label text-justify" *ngIf="answer?.answerContent?.gptEvalStatus === gptEvalStatusEnum.Waiting || answer?.answerContent?.gptEvalStatus === 99">
            {{"Key.WaitForAIComment" | translate}}
        </div>
    </div>
</div>